import * as Sentry from '@sentry/browser'
import lodash from 'lodash'
import { toast } from 'react-toastify'
import { all, put, takeLatest } from 'redux-saga/effects'

import { request } from '../../../1stlog-ui/src/utils'
import {
  receiveCreate,
  receiveDelete,
  receiveImport,
  receiveUpdate,
  set,
} from './actions'
import {
  REQUEST_CREATE,
  REQUEST_DELETE,
  REQUEST_IMPORT,
  REQUEST_UPDATE,
  SET,
} from './constants'
// import { applyFilter } from "containers/AddressBookNew/actions" // sowas darf hier nicht gecalled werden - muss in der liste selbst gehooked werden (siehe AddressBookNew/saga.js)

const saga = 'containers/AddressModal/saga'

export default function* root() {
  try {
    yield all([
      takeLatest(SET, handleSet),
      takeLatest(REQUEST_CREATE, handleRequestCreate),
      takeLatest(REQUEST_UPDATE, handleRequestUpdate),
      takeLatest(REQUEST_DELETE, handleRequestDelete),
      takeLatest(REQUEST_IMPORT, handleRequestImport),
    ])
  } catch (error) {
    console.error(error)
    Sentry.captureMessage(error, { extra: { error, saga } })
  }
}

export function* handleRequestCreate({ payload }) {
  try {
    let { data } = yield request({
      method: 'put',
      url: `/api/addressbook`,
      data: payload,
    })
    yield put(receiveCreate({ result: data }))
    yield put(set({ isOpen: false }))
    toast.success(i18n.t('address_was_added', 'Adresse wurde hinzugefügt.'))
  } catch (error) {
    console.error(error)
    yield put(receiveCreate({ error }))
    toast.error(
      i18n.t(
        'adding_the_address_failed_please_try_again',
        'Hinzufügen der Adresse fehlgeschlagen! Bitte erneut versuchen.',
      ),
    )
    Sentry.captureMessage(error, {
      extra: { saga, payload },
    })
  }
}

export function* handleRequestUpdate({ payload }) {
  const { id } = payload ?? {}
  try {
    let { data, status } = yield request({
      method: 'patch',
      url: `/api/addressbook/${id}`,
      data: payload,
    })
    yield put(receiveUpdate({ result: data }))
    yield put(set({ isOpen: false }))
    toast.success(i18n.t('address_was_updated', 'Adresse wurde aktualisiert.'))
  } catch (error) {
    console.error(error)
    yield put(receiveUpdate({ error }))
    toast.error(
      i18n.t(
        'updating_the_address_failed_please_try_again',
        'Aktualisieren der Adresse fehlgeschlagen! Bitte erneut versuchen.',
      ),
    )
    Sentry.captureMessage(error, {
      extra: { saga, payload },
    })
  }
}

export function* handleRequestDelete({ payload }) {
  const { id } = payload ?? {}
  try {
    let { data } = yield request({
      method: 'delete',
      url: `/api/addressbook/${id}`,
      data: payload,
    })
    yield put(receiveDelete({ result: data }))
    yield put(set({ isOpen: false }))
    toast.success(i18n.t('address_was_deleted', 'Adresse wurde gelöscht.'))
  } catch (error) {
    console.error(error)
    yield put(receiveDelete({ error }))
    toast.error(
      i18n.t(
        'deleting_the_address_failed_please_try_again',
        'Löschen der Adresse fehlgeschlagen! Bitte erneut versuchen.',
      ),
    )
    Sentry.captureMessage(error, {
      extra: { saga, payload },
    })
  }
}

export function* handleRequestImport({ payload }) {
  try {
    const formData = new FormData()
    lodash.forOwn(payload, (value, key, _object) => {
      if (!value) return
      formData.append(key, value)
    })
    let { data } = yield request({
      method: 'post',
      url: `/api/addressbook/upload/csv`,
      data: formData,
    })
    yield put(receiveImport({ result: { ...data, values: payload } }))
  } catch (error) {
    console.error(error)
    yield put(receiveImport({ error }))
    toast.error(
      i18n.t(
        'import_failed_please_try_again',
        'Import fehlgeschlagen! Bitte erneut versuchen.',
      ),
    )
    Sentry.captureMessage(error, {
      extra: { saga, payload },
    })
  }
}

// eslint-disable-next-line require-yield
export function* handleSet({ payload }) {
  if (lodash.has(payload, 'isOpen') && !!lodash.get(payload, 'reload')) {
    console.log(
      'TODO: handleSet was calling applyFilter (now hooked in AddressBookNew). Check if still required.',
    )
    // TODO: was soll das hier?
    // yield put(applyFilter({ reset: true }))
  }
}
